<ion-content class="ion-padding" [fullscreen]="true">
	<h1>{{'Idioma' | translate}}</h1>

	<ion-radio-group (ionChange)="changeLang($event)" [value]="language">
		<ion-radio labelPlacement="end" value="pt">Português</ion-radio><br />
		<ion-radio labelPlacement="end" value="en">English</ion-radio><br />
		<ion-radio labelPlacement="end" value="es">Español</ion-radio>
	</ion-radio-group>
</ion-content>
